<section class="new-contract-select-offer__container">
  <h2 class="new-contract-select-offer__title">
    {{ 'NEW_CONTRACT_LA.TITLE_SELECT_OFFER' | i18nextEager | uppercase }}
  </h2>
  <form [formGroup]="offerForm" class="new-contract-select-offer__form">
    <div>
      <app-custom-select
        [label]="'NEW_CONTRACT_LA.SELECT_OFFER'"
        [controlName]="'offer'"
        [values]="offersList"
        [defaultValue]="offerForm.get('offer').value"
        [searchBar]="true"
        [preload]="true"
        [minLength]="3"
        [(showMore)]="showMore"
        (getData)="getOffers($event)"
      ></app-custom-select>
      <mat-error
        *ngIf="
          offerForm.get('offer').errors?.required && (offerForm.get('offer').touched || offerForm.get('offer').dirty)
        "
      >
        {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
      </mat-error>
    </div>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'NEW_CONTRACT_LA.OMIP' | i18nextEager }}</mat-label>
      <input matInput formControlName="omip" maxlength="6" decimal />
      <mat-error
        *ngIf="
          (offerForm.get('omip').errors?.required || !offerForm.get('omip').errors?.valid) &&
          (offerForm.get('omip').touched || offerForm.get('omip').dirty)
        "
      >
        {{ 'NEW_CONTRACT_LA.NUMERIC_ERROR' | i18nextEager }}
      </mat-error>
    </mat-form-field>
    <div class="new-contract-select-offer__container-input">
      <span class="new-contract-select-offer__title-input">{{
        'NEW_CONTRACT_LA.CREDIT_ANALYSIS' | i18nextEager | uppercase
      }}</span>
      <div class="new-contract-select-offer__container-label">
        <ng-container *ngIf="approved && callQuery">
          <img src="/assets/icons/approved.svg" alt="{{ 'NEW_CONTRACT_LA.APPROVED' | i18nextEager }}" />
          <span class="new-contract-select-offer__label">{{ 'NEW_CONTRACT_LA.APPROVED' | i18nextEager }}</span>
        </ng-container>
        <ng-container *ngIf="!approved && callQuery">
          <img src="/assets/icons/rejected.svg" alt="{{ 'NEW_CONTRACT_LA.REJECTED' | i18nextEager }}" />
          <span class="new-contract-select-offer__label">{{ 'NEW_CONTRACT_LA.REJECTED' | i18nextEager }}</span>
        </ng-container>
        <button class="new-contract-select-offer__button" [disabled]="offerForm.invalid" (click)="handleQuery()">
          {{ 'NEW_CONTRACT_LA.QUERY' | i18nextEager }}
        </button>
      </div>
    </div>
  </form>
</section>
